export default __webpack_public_path__ + "8e4251e218ae7c67951019f5d73b0338.png";